export const BEARER = 'Bearer';

